// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GJAn","largestCol":"styles_largestCol__2GkLL","smallestCol":"styles_smallestCol__wXHV5"};